// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TF-z","twoColumnImage":"UF-z"};